module.exports = __webpack_public_path__ + "static/media/finger_authen_white.f75cb83f.svg";